import { Query } from '../../hooks/queries'
import { useContrastQuery } from '../../hooks/use-contrast-query'
import { ProtectRule } from '../protect-rules'
import {
  CveShieldsQueryArgs,
  getCveShieldsSummary
} from '../../api/queries/cve-shields/cve-shields-summary'

interface CveShieldParams {
  readonly expand: string
}

export function useCveShieldsSummary(
  organizationUuid: string,
  cveShieldParams?: CveShieldParams
) {
  return useContrastQuery<CveShieldsQueryArgs, ProtectRule[]>(
    [Query.CVE_SHIELDS_SUMMARY],
    getCveShieldsSummary,
    {
      organizationUuid,
      ...cveShieldParams
    },
    { notifyOnChangeProps: 'tracked' }
  )
}
